import { NgModule } from "@angular/core";

import { AncestorScrollDirective } from "./ancestor-scroll.directive";
import { ClickOutDirective } from "./click-out.directive";
import { HoverableModule } from "./hoverable";
import { InteractDirective } from "./on-interaction.directive";
import { SelectTextDirective } from "./select-text.directive";

@NgModule({
  declarations: [
    AncestorScrollDirective,
    ClickOutDirective,
    InteractDirective,
    SelectTextDirective
  ],
  exports: [
    AncestorScrollDirective,
    ClickOutDirective,
    HoverableModule,
    InteractDirective,
    SelectTextDirective
  ]
})
export class UserActionDirectivesModule {}
